import { url } from "../services/url.service"

export const generateFilePath = (fileName) => {
    if (fileName && typeof fileName == 'string') {
        return `${url}/uploads/${fileName}`
    }
    return fileName
}